<template>
  <main id="view-search-machines-results" class="products-research-view">

    <transition name="fade">
    <filters-list-mobile
        v-show="filtersMobileVisible" :filters="filtersList"></filters-list-mobile>
    </transition>

    <transition name="fade">
      <sort-list-mobile
          v-show="sortMobileVisible"></sort-list-mobile>
    </transition>

    <transition name="fade" >
      <div v-show="!filtersMobileVisible && !sortMobileVisible">
      <results-title v-if="!isPhone"></results-title>
      <results-title-mobile v-else></results-title-mobile>
      <div class="results-wrapper">

        <category-list
            v-if="!isPhone || (isPhone && selectedCategory.code==='machines' && selectedCategory.code!=='best-seller')"></category-list>


        <div class="product-wrapper" v-if="!isPhone || (isPhone && selectedCategory)">

          <filters-list
              v-if="filtersList.length>0 && selectedCategory.code!=='machines' && selectedCategory.code!=='best-seller' && selectedCategory.code!=='low-emission' && !isPhone && !isTablet && resultsLoaded"></filters-list>

          <results-header
              :total="total"
              :selected-view="selectedView"
              v-if="selectedCategory.code!=='machines' && selectedCategory.code!=='best-seller' && selectedCategory.code!=='low-emission' && !isPhone && !isTablet && resultsLoaded "></results-header>

          <results-header-mobile
              :total="total"
              v-if="selectedCategory.code!=='machines' && selectedCategory.code!=='best-seller' && selectedCategory.code!=='low-emission' && (isPhone || isTablet) && resultsLoaded"></results-header-mobile>

          <div class="spotlight_title" v-if="selectedCategory.code==='machines' && !marketFilter">{{$t('in_spotlight')}}</div>
          <div class="spotlight_title" v-if="selectedCategory.code==='machines' && marketFilter">{{$t('all_machines')}}</div>

          <row-view
              v-if="!isPhone && selectedView==='row' && resultsLoaded && results.length > 0"></row-view>

          <card-view
              v-if="(selectedView==='card' || isPhone) && resultsLoaded && results.length > 0"></card-view>

          <div class="no-results" v-else-if="selectedCategory.code!=='machines' && selectedCategory.code!=='best-seller' && resultsLoaded && results.length===0">
            <span class="text">{{ $tc('results_count', 0) }}</span>
            <span class="subtext">{{ $t('please_enlarge_your_filter') }}</span>
          </div>

        </div>

      </div>
      </div>
    </transition>
  </main>
</template>


<script>
import {mapState, mapGetters} from 'vuex'
import stickyMixins from "@/common/mixins/sticky";

import {convertFiltersArray, triggerTrackingEvent} from "@/common/helpers";

import filtersMixins from "@/common/mixins/filters";
import productService from '@/services/serli/product'


import FiltersList from "@/components/ResearchBlock/machines/FiltersList";
import FiltersListMobile from "@/components/ResearchBlock/machines/FiltersListMobile";
import SortListMobile from "@/components/ResearchBlock/machines/SortListMobile";
import CategoryList from "@/components/ResearchBlock/machines/CategoryList";
import RowView from "@/components/ResearchBlock/machines/RowView";
import CardView from "@/components/ResearchBlock/machines/CardView";
import ResultsHeader from "@/components/ResearchBlock/machines/ResultsHeader";
import ResultsHeaderMobile from "@/components/ResearchBlock/machines/ResultsHeaderMobile";
import ResultsTitle from "@/components/ResearchBlock/machines/ResultsTitle";
import ResultsTitleMobile from "@/components/ResearchBlock/machines/ResultsTitleMobile";


import stickybits from "stickybits";

export default {
  name: 'searchMachinesResults',
  mixins: [stickyMixins, filtersMixins],
  components: {
    FiltersList,
    FiltersListMobile,
    SortListMobile,
    CategoryList,
    RowView,
    CardView,
    ResultsHeader,
    ResultsHeaderMobile,
    ResultsTitle,
    ResultsTitleMobile
  },
  data() {
    return {
      categoriesLoaded: false,
      showFiltersMobile: false,
      resultsLoaded: false,
      resultsLoadedFirst: false,
      filtersLoaded: true,
      currentPage: 1,
      filtersMobileVisible: false,
      sortMobileVisible: false
    }
  },
  computed: {
    ...mapState({
      categories: state => state.settings.categories,
      filters: state => state.searchMachines.filters,
      filtersList: state => state.searchMachines.filtersList,
      selectedView: state => state.searchMachines.selectedView,
      results: state => state.searchMachines.results,
      sort: state => state.searchMachines.sort,
      total: state => state.searchMachines.total,
      isLargeDesktop: state => state.settings.isLargeDesktop,
      isSmallDesktop: state => state.settings.isSmallDesktop,
      isTablet: state => state.settings.isTablet,
      isPhone: state => state.settings.isPhone,
      asyncCategories: state => state.settings.asyncCategories,
      activeCategories: state => state.searchMachines.activeCategories,
      selectedCategory: state => state.searchMachines.category,
      unitType: state=>state.settings.unitType,
      firstLoad : state=>state.searchMachines.firstLoad,
      marketFilter: state => state.searchMachines.marketFilter,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    itemsPerPage() {
      if (this.isLargeDesktop)
        return 21
      if (this.isSmallDesktop)
        return 16
      if (this.isTablet)
        return 12
      if (this.isPhone)
        return 10
      return 24;
    },

    filterNumber() {
      if (this.isLargeDesktop)
        return 4
      if (this.isSmallDesktop)
        return 3
      if (this.isTablet)
        return 3
      if (this.isPhone)
        return 4
      return 4;
    },

    activeFiltersCount() {
      let count = 0;
      this.filters.forEach(filter => {
        if (this.isDisplayableFilter(filter))
          count++;
      })

      return count;
    },

  },

  created() {
    if (this.$route.query.init) {
      this.$store.commit('searchMachines/reset');
    }
    if (!this.$route.query.return) {
      if (!this.isPhone) this.searchResults()
    } else {
      this.resultsLoaded = true
    }

  },
  mounted() {

    this.$root.$on('change-market-filter', (marketFilter) => {
      this.$store.commit('searchMachines/reset');
      this.$store.commit('searchMachines/setMarketFilter',marketFilter);
      this.$store.commit('searchMachines/setFirstLoad', true);
      this.searchResults()
    })

    this.$root.$on('remove-market-filter', () => {
      this.$store.commit('searchMachines/reset');
      this.$store.commit('searchMachines/setMarketFilter',null);
      this.$store.commit('searchMachines/setFirstLoad', true);
      this.searchResults()
    })

    this.$root.$on('open-filters-mobile', () => {
      this.filtersMobileVisible = true
    })

    this.$root.$on('close-filters-mobile', () => {
      this.filtersMobileVisible = false
    })

    this.$root.$on('open-sort-mobile', () => {
      this.sortMobileVisible = true
    })

    this.$root.$on('close-sort-mobile', () => {
      this.sortMobileVisible = false
    })

    this.$root.$on('research-machines', () => {
      this.searchResults()
    })

    this.$root.$on('select_sort', (attribute) => {
      this.selectSort(attribute)
    })

    this.$root.$on('select_view', (view) => {
      this.$store.commit('searchMachines/setView', view)
    })

    this.$root.$on('filters_reset', () => {
      //this.$store.commit('searchMachines/setFirstLoad',true);
      this.reloadCategory()
    })

    if (!this.isPhone) {
      setTimeout(() => {
        this.$nextTick(() => {
          stickybits('.categories-wrapper', {stickyBitStickyOffset: 100});
          stickybits('.results-header', {stickyBitStickyOffset: 100});
        })
      }, 500)
    }

  },

  watch: {
    async selectedCategory() {
     await this.reloadCategory()
    }
  },

  methods: {
    async selectCategory(category) {
      await this.searchResults()
    },

    async reloadCategory() {
      this.$store.commit('searchMachines/setFilters',[]);
      const filterDatas=this.selectedCategory['filtersList']

      if(this.selectedCategory.code!=='machines' && this.selectedCategory.code!=='best-seller' && this.selectedCategory.code !== 'low-emission') {
        let filtersArray = [];
        filterDatas.forEach((filter) => {
          if (filter.code !== 'machine_brand') filtersArray.push(filter)
        })

        //Cas particulier des warehousing
        if(this.selectedCategory.code==='warehousing') {
          //retirer max_capacity
          const index = filtersArray.findIndex((x)=>x.code==='max_capacity')
          delete filtersArray[index]
          //ajouter la segmentation
          filtersArray.push({
            code:'commercial_segmentation',
            filter_details: {
              type:'select'
            },
            label : this.$t('warehousing_segmentation'),
            unit : 'null',
            options: [
              {code : "easy_segmentation", label:"Easy"},
              {code : "teknik_segmentation", label:"Teknik"}
            ]
          })
        }

        const _self = this
        await this.generateFiltersArray(filtersArray).then((response) => {
          response.sort(function (a, b) {
            if (a.key < b.key)
              return -1;
            if (a.key > b.key)
              return 1;
          })
          _self.$store.commit('searchMachines/setFiltersList', response.slice(0, _self.filterNumber));
          _self.resultsLoaded = false;

        }).finally(() => {
          _self.searchResults()
        });

      } else await this.searchResults()
    },

    displayCurrentFilter(filter) {
      let filter_datas_displayed = filter.title + ' : ';
      if (filter.type === 'slider')
        filter_datas_displayed += filter.minValue + ' - ' + filter.maxValue + ' ' + filter.unit
      if (filter.type === 'select' || filter.type === 'boolean') {
        filter_datas_displayed += filter.options.find(x => x.code === filter.value).label
      }
      return filter_datas_displayed;
    },
    isDisplayableFilter(filter) {
      return (filter.type !== 'select' || (filter.type === 'select' && filter.value !== ''));
    },
    showHideFilters() {
      this.showFiltersMobile = !this.showFiltersMobile;
    },
    deleteFilter(index) {
      this.$store.commit('searchMachines/deleteFilter', index);
      this.searchResults();
    },
    deleteRangeFilter() {
      this.$store.commit('searchMachines/setRange', null);
      this.searchResults();
    },

    findFirstActiveCategory() {
     if(this.activeCategories.length>0)
       return this.asyncCategories.find((cat)=>this.activeCategories.includes(cat.code))
       else {
         return this.asyncCategories[0]
      }
    },

    async searchResults(with_loading = true) {
      let filters = JSON.parse(JSON.stringify(this.filters));
      filters = await convertFiltersArray(filters);
      var sort = this.sort.split('/')
      this.resultsLoaded = false;
      if (with_loading) this.startLoading();
      await productService.list({
        filters: filters
      }, {
        productType: 'machines',
        brand: this.$store.state.settings.brand,
        category: this.selectedCategory && (this.selectedCategory.code!=='best-seller' && this.selectedCategory.code !== 'low-emission') ? this.selectedCategory.code : 'machines',
        full: false,
        size: 999,
        page: 1,
        //size: this.itemsPerPage,
        //page : this.currentPage,
        locale: this.localeKebabFormat,
        sortAttribute: sort[0],
        sortAsc: sort[1],
        unit:this.unitType,
        market: this.marketFilter ? this.marketFilter.code : '',
      })
          .then((response) => {
            if (response.data.code === 200) {
              if (this.activeCategories.length===0 && this.marketFilter) {
                let firstResults = []
                firstResults = response.data.data;
                let activeCategories = [];
                let cat = null;

                firstResults.forEach((result) => {
                  result.categories.forEach((category) => {
                    cat = this.categories.find((c) => c.code === category)
                    if (cat && activeCategories.indexOf(cat.parent) === -1) {
                      activeCategories.push(cat.parent);
                    }
                  })
                  if (result.isBestSeller && activeCategories.indexOf('best-seller') === -1) {
                    activeCategories.push('best-seller');
                  } else if (result.isOxygen && activeCategories.indexOf('low-emission') === -1) {
                    activeCategories.push('low-emission');
                  }
                })

                this.$store.commit('searchMachines/setActiveCategories', activeCategories);
                this.$store.commit('searchMachines/setFirstLoad', false);
              }
              var results = [];
              if (this.selectedCategory.code === 'machines') {
                //this.$store.commit('searchMachines/setResults', response.data.data);

                if(this.marketFilter) results=response.data.data
                else response.data.data.forEach((result) => {
                  if (result.isNew) {
                    results.push(result)
                  }
                })

                //response.data.data.forEach((result) => {
                //  if (result.isNew) {
                //    results.push(result)
                //  }
                //})

                if(results.length===0) this.$store.commit('searchMachines/setCategory', this.findFirstActiveCategory())
                this.$store.commit('searchMachines/setTotal', results.length);
                this.$store.commit('searchMachines/setResults', results);

              } else if (this.selectedCategory.code === 'best-seller') {


                this.$store.commit('searchMachines/setResults', response.data.data);
                this.results.forEach((result) => {
                  if (result.isBestSeller) {
                    results.push(result)
                  }
                })

                this.$store.commit('searchMachines/setFiltersList', []);

                if(results.length===0) this.$store.commit('searchMachines/setCategory', this.findFirstActiveCategory())
                this.$store.commit('searchMachines/setTotal', results.length);
                this.$store.commit('searchMachines/setResults', results);

              } else if (this.selectedCategory.code === 'low-emission') {


                this.$store.commit('searchMachines/setResults', response.data.data);
                this.results.forEach((result) => {
                  if (result.isOxygen) {
                    results.push(result)
                  }
                })

                this.$store.commit('searchMachines/setFiltersList', []);

                if(results.length===0) this.$store.commit('searchMachines/setCategory', this.findFirstActiveCategory())
                this.$store.commit('searchMachines/setTotal', results.length);
                this.$store.commit('searchMachines/setResults', results);

              } else {
                this.possibleAttribute = response.data.data.possibleAttributeValues;
                this.$store.commit('searchMachines/setResults', response.data.data.results);
                this.$store.commit('searchMachines/setTotal', response.data.data.total);
              }
              //@todo on conserve ?
              //if (this.new) this.$store.commit('searchMachines/setResults', response.data);
              if (this.results.total === 0) {
                /*gtag('event', 'result_no_machine_found', {
                  'event_category': 'result',
                  'event_label': "Affichage d'une page de résultat de recherche machines vide"
                });*/

                triggerTrackingEvent('result_no_machine_found', 'result', "Affichage d'une page de résultat de recherche machines vide")
              }
            }
          })
          .finally(() => {
            this.resultsLoaded = true;
            window.scrollTo(0,0);
            if (with_loading)
              this.stopLoading()

          });
    },

    selectSort(code) {

      const softSort=[
          'name/0',
          'name/1',
          'isBestSeller/0',
          'isNew/0'
      ]

      if (this.selectedView === 'row') {
        if (this.sort === code + '/1')
          this.$store.commit('searchMachines/setSort', code + '/0');
        else this.$store.commit('searchMachines/setSort', code + '/1');
        //this.searchResults();
      }

      if (this.selectedView === 'card') {
        this.$store.commit('searchMachines/setSort', code);
        //this.searchResults();
      }

      let results=this.results

      if(this.sort==='name/1') {
        results.sort(function compare(a, b) {
          var aname=a.name.replace(' ','')
          var bname=b.name.replace(' ','')
          if (aname < bname )
            return -1;
          if (aname > bname)
            return 1;
        })
      }

      if(this.sort==='name/0') {
        results.sort(function compare(a, b) {
          var aname=a.name.replace(' ','')
          var bname=b.name.replace(' ','')
          if (aname > bname )
            return -1;
          if (aname < bname)
            return 1;
        })
      }

      if(this.sort==='isBestSeller/0') {
        results.sort(function compare(a, b) {
          if (!a.isBestSeller && !b.isBestSeller  )
            return 0;
          if (a.isBestSeller > b.isBestSeller || !b.isBestSeller )
            return -1;
          if (a.isBestSeller < b.isBestSeller || !a.isBestSeller)
            return 1;
        })
      }

      if(this.sort==='isNew/0') {
        results.sort(function compare(a, b) {
          if (!a.isNew && !b.isNew  )
            return 0;
          if (a.isNew > b.isNew || !b.isNew )
            return -1;
          if (a.isNew < b.isNew || !a.isNew)
            return 1;
        })
      }

      if(!softSort.includes(this.sort)) {
        var sort = this.sort.split('/')
        var resultsTemp=results
        resultsTemp.sort(function compare(a, b) {

          var avalue=a.minimalAttributes.find(x=>x.code===sort[0])
          var bvalue=b.minimalAttributes.find(x=>x.code===sort[0])

          if(!avalue && !bvalue)
            return 0
         else if (!avalue || (bvalue && parseFloat(avalue.value.data.raw.amount) < parseFloat(bvalue.value.data.raw.amount)) )
           return -1;
         else if (!bvalue || avalue && (parseFloat(avalue.value.data.raw.amount) > parseFloat(bvalue.value.data.raw.amount)) )
           return 1;
        })

        if(sort[1]==='0')
        {(console.log('inversion'))
          results = resultsTemp.reverse()}
        else results = resultsTemp



      }

      this.$store.commit('searchMachines/setResults', results);
    },


  }
}
</script>

<style lang="scss">

</style>
